import Constants from '@intercom/embercom-composer/lib/constants';
import stripAttrs from '@intercom/embercom-composer/lib/strip-data-attributes';
export function editorHasAnyContent($editor) {
  if (!$editor) {
    return false;
  }
  let html = stripAttrs($editor.html()).replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '').replace('<!---->', '');
  return !isEmptyTextHtml(html);
}
export function editorHasSubstantialContent($editor) {
  if (!$editor) {
    return false;
  }
  return hasNonParagraphChildNodes($editor) || hasText($editor);
}
function hasNonParagraphChildNodes($editor) {
  let children = $editor[0].childNodes;
  if (children) {
    for (let i = 0; i < children.length; i++) {
      // Ignoring childNodes that are not elements.
      if (children[i].nodeType === Node.ELEMENT_NODE && children[i].tagName !== 'P') {
        return true;
      }
    }
  }
  return false;
}
export function hasText($editor) {
  return $editor.text().replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '').trim().length !== 0;
}
function isEmptyTextHtml(html) {
  if (html) {
    return Constants.EMPTY_TEXT_HTML_REGEX.test(html);
  } else {
    return false;
  }
}